export default __webpack_public_path__ + "static/media/151-up-1.de48e58b.png";